import { render } from "./GetTabletModal.vue?vue&type=template&id=5eab02e2"
import script from "./GetTabletModal.vue?vue&type=script&lang=js"
export * from "./GetTabletModal.vue?vue&type=script&lang=js"

import "./GetTabletModal.vue?vue&type=style&index=0&id=5eab02e2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__